import * as React from "react";
import styled from "styled-components";
import { Palette } from "../../vars";
import { KEY_ESC, KEY_TAB } from "./dropdown.consts";

export class HoverDropdown extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  handleOpenEvent = () => {
    this.setState(this.openDropdown);
  };

  handleCloseEvent = () => {
    this.setState(this.closeDropdown);
  };

  openDropdown = () => ({ open: true });

  closeDropdown = () => ({ open: false });

  // TODO: Add functionality to focus menu item children
  handleKeyDown = e => {
    switch (e.keyCode) {
      case KEY_TAB:
        if (!this.state.open) {
          if (!e.shiftKey) {
            this.handleOpenEvent();
          }
        } else {
          if (e.shiftKey) {
            this.handleCloseEvent();
          }
        }

        break;
      case KEY_ESC:
        this.handleCloseEvent();
        break;
      default:
    }
  };

  handleToggleFocus = _ => {
    this.handleOpenEvent();
  };

  addTogglePropsToChild = ChildComponent =>
    React.cloneElement(ChildComponent, {
      open: this.state.open,
      onFocus: this.handleToggleFocus
    });

  addMenuPropsToMenu = MenuComponent =>
    React.cloneElement(MenuComponent, {
      open: this.state.open,
      onCloseButtonClick: this.handleCloseEvent
    });

  render() {
    let { children, className, menu, ...otherProps } = this.props;

    menu = this.addMenuPropsToMenu(menu);

    children = React.Children.map(children, this.addTogglePropsToChild);

    return (
      <div
        className={className}
        onKeyDown={this.handleKeyDown}
        onMouseEnter={this.handleOpenEvent}
        onMouseLeave={this.handleCloseEvent}
        {...otherProps}
      >
        {children}
        {menu}
      </div>
    );
  }
}

export default styled(HoverDropdown)`
  position: relative;

  > div {
    > .md-icon {
      color: ${Palette.Rebrand.Colours.P4};
      &.symbol {
        margin-bottom: 5px;
        margin-right: 10px;
      }

      &.chevron {
        margin-bottom: 2px;
        color: ${Palette.Rebrand.Colours.G4};
      }
    }
  }

  &:hover {
    > div {
      > i,
      > span {
        color: ${Palette.Rebrand.Colours.P2};
      }

      > .md-icon {
        &.chevron {
          color: ${Palette.Rebrand.Colours.P2};
        }
      }
    }
  }
`;
